import type { GiftSearchAgeGroup, TheaWebSearchGiftsResponse } from '../schemas/endpoints/theaWebSearchGifts';
import { normalizeHubAges } from './hubTopic';

export const SEARCH_AGES: { key: string; name: string; label: string; bands: GiftSearchAgeGroup[] }[] = [
  // Approved overlap: the 2–6 month wire band belongs to both friendly labels.
  { key: 'newborn', name: 'Newborn', label: 'Newborn (0–3 months)', bands: ['NEWBORN_0_2_MONTHS', 'YOUNG_INFANT_2_6_MONTHS'] },
  { key: 'baby', name: 'Baby', label: 'Baby (3–12 months)', bands: ['YOUNG_INFANT_2_6_MONTHS', 'OLDER_INFANT_6_12_MONTHS'] },
  { key: 'toddler', name: 'Toddler', label: 'Toddler (1–2 years)', bands: ['TODDLER_1_3_YEARS'] },
  { key: 'preschool', name: 'Preschool', label: 'Preschool (3–5 years)', bands: ['PRESCHOOL_3_5_YEARS'] },
  { key: 'elementary', name: 'Elementary School', label: 'Elementary School (6–10 years)', bands: ['ELEMENTARY_6_10_YEARS'] },
  { key: 'middle', name: 'Middle School', label: 'Middle School (11–14 years)', bands: ['MIDDLE_SCHOOL_11_14_YEARS'] },
  { key: 'high', name: 'High School', label: 'High School (14–18 years)', bands: ['HIGH_SCHOOL_14_18_YEARS'] },
  { key: 'adult', name: 'Adult', label: 'Adult', bands: ['YOUNG_ADULT', 'OLDER_ADULT'] },
];
export const searchAgeBands = (keys: readonly string[]) => normalizeHubAges(
  SEARCH_AGES.filter(age => keys.includes(age.key)).flatMap(age => age.bands),
);
export const readSearchAges = (params: URLSearchParams): string[] => {
  // Keep friendly selections as well as wire bands: the overlapping infant
  // band cannot uniquely identify which checkboxes the shopper selected.
  if (params.has('ages')) return SEARCH_AGES.filter(age => params.getAll('ages').includes(age.key)).map(age => age.key);
  const bands = params.getAll('age');
  return SEARCH_AGES.filter(age => age.bands.some(band => bands.includes(band))).map(age => age.key);
};
export const searchHasNoMatches = (response: TheaWebSearchGiftsResponse | null | undefined, guideCount = response?.guides?.length ?? 0) =>
  response?.relevance?.confidence === 'low' && guideCount === 0 && response.query.intent === 'search';

export function searchReturnState(href: string, scrollY: number) {
  return { hubSearchReturn: { href, scrollY } };
}
export function readSearchReturn(state: unknown): { href: string; scrollY: number } | null {
  const value = (state as { hubSearchReturn?: { href?: unknown; scrollY?: unknown } } | null)?.hubSearchReturn;
  if (typeof value?.href !== 'string' || !/^\/gift-guides\/search\?/.test(value.href) || /[\\\r\n]/.test(value.href)) return null;
  return { href: value.href, scrollY: savedSearchScroll(value.href) ?? (typeof value.scrollY === 'number' && Number.isFinite(value.scrollY) ? Math.max(0, value.scrollY) : 0) };
}

export function saveSearchScroll(href: string, top: number) {
  try { sessionStorage.setItem(`hub-search:${href}`, String(top)); } catch { /* storage can be disabled */ }
}
export function savedSearchScroll(href: string): number | null {
  try {
    const value = sessionStorage.getItem(`hub-search:${href}`);
    const top = value === null ? NaN : Number(value);
    return Number.isFinite(top) ? Math.max(0, top) : null;
  } catch { return null; }
}
